import { getArtworkTrending } from '@/services';
import type { AssetTrendingMarketplace } from '@/types/asset';
import { useSQuery } from '@/utils';

const useTrendingBanner = () => {
  const { data, isLoading } = useSQuery({
    queryKey: ['get-top-asset-banner'],
    queryFn: () => getArtworkTrending(),
    keepPreviousData: true,
  });
  const list: AssetTrendingMarketplace[] = data?.data?.items || [];

  return { list, isLoading };
};

export default useTrendingBanner;
